import "./alert.css";
import React from "react";
import { AlertContext } from "../context/alertContext";
import qrcode from "./shared_qr_code.png";

export const Whatsapp = () => {
  const { qr, hideQr } = React.useContext(AlertContext);
  return (
    <div ref={qr} className="qrDiv">
      <div className="qr alert">
        <div>
          <div>
            <img src={qrcode} />
          </div>
          <div>
            <button onClick={hideQr}>Done</button>
          </div>
        </div>
      </div>
    </div>
  );
};
